import { useMemo } from 'react';
import useCachedCollection from '../../../hooks/useCachedCollection';

// Marka listesi neredeyse hiç değişmez (yalnızca yeni bir marka/model kaydedildiğinde,
// bkz. utils/brandSync.js). Kalıcı realtime listener yerine paylaşımlı oturum cache'i
// kullanılır; brandSync yazma sonrası cache'i geçersiz kılar.
export const useDeviceBrands = () => {
    const { data, loading } = useCachedCollection('brands');

    const brandsFromDb = useMemo(
        () => [...data].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'tr')),
        [data]
    );

    return { brandsFromDb, loading };
};
